export default __webpack_public_path__ + "assets/e10f30bf483add0ae380d4fbc675a8a9.png";